import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "./components/landing/Header";
import Footer from "./components/landing/Footer";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import AdminEngagement from "./pages/AdminEngagement";
import PortalLogin from "./portal/PortalLogin";
import PortalSetPassword from "./portal/PortalSetPassword";
import PortalLayout from "./portal/PortalLayout";
import PortalDashboard from "./portal/PortalDashboard";
import PortalEngagement from "./portal/PortalEngagement";
import PortalAccount from "./portal/PortalAccount";
import { setLenisInstance } from "./lib/scroll";

const NotFound = () => (
  <section className="py-32 md:py-44 text-center px-4">
    <p className="font-mono text-xs uppercase tracking-[0.3em] text-ochre mb-6">404</p>
    <h1 className="font-serif text-4xl sm:text-5xl mb-8">That page does not exist.</h1>
    <Link to="/" data-testid="notfound-home-link" className="font-mono text-sm uppercase tracking-[0.2em] px-10 py-4 bg-ember text-ink hover:bg-emberDeep transition-colors duration-300">Back to home</Link>
  </section>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

const Site = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenisInstance(lenis);
    const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    return () => { lenis.destroy(); setLenisInstance(null); };
  }, []);
  return (
    <>
      <Header />
      <main className="pt-16">{children}</main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="relative bg-ink text-bone min-h-screen selection-ember">
      <Toaster position="bottom-right" richColors theme="dark" />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Site><Home /></Site>} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/briefing-requests" element={<Admin initialTab="briefings" />} />
          <Route path="/admin/engagements" element={<Admin initialTab="portal" />} />
          <Route path="/admin/engagements/:id" element={<AdminEngagement />} />
          <Route path="/portal/login" element={<PortalLogin />} />
          <Route path="/portal/set-password" element={<PortalSetPassword />} />
          <Route path="/portal" element={<PortalLayout><PortalDashboard /></PortalLayout>} />
          <Route path="/portal/engagements/:id" element={<PortalLayout><PortalEngagement /></PortalLayout>} />
          <Route path="/portal/account" element={<PortalLayout><PortalAccount /></PortalLayout>} />
          <Route path="*" element={<Site><NotFound /></Site>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
